import {isEmpty, map, isArray, isObjectLike} from "lodash";
import {message} from "antd";
import * as Sentry from "@sentry/browser";


export const parseResponseError = (error: any) => {
    if (error instanceof Error) {
        if (error.message === 'Network Error') {
            return 'Network error. Try refreshing the page.'
        }
    }
    if (error.body) {
        return error.body.message;
    }
    if (!error.response) {
        if (!navigator.onLine) {
            return "There is no internet connection";
        }
        console.error(error);
        Sentry.captureException(error);
        return "Unexpected error occurred. Please contact support"
    } else {
        const dataDetails = error.response.data.error?.details;
        if (dataDetails) {
            if (dataDetails.non_field_errors) {
                return dataDetails.non_field_errors.join(' ')
            }
            if (dataDetails.details) {
                return dataDetails.details
            }
            if (dataDetails.detail) {
                return dataDetails.detail
            }
            if (dataDetails.message) {
                return dataDetails.message
            }
            if (isArray(dataDetails)) {
                return dataDetails.map(err => err.non_field_errors ? err.non_field_errors.join(' ') : err).join(', ')
            }
            if (error.response.status === 400 && !isEmpty(dataDetails)) {
                return map(dataDetails, (errorMessage, fieldName) => {
                    if (errorMessage.message) {
                        errorMessage = errorMessage.message;
                    }
                    if (isObjectLike(errorMessage) && 'non_field_errors' in errorMessage) {
                        return (
                            <span style={{display: "block"}}>
                            {fieldName}: {isArray(errorMessage.non_field_errors) ? errorMessage.non_field_errors.join(' ') : errorMessage.non_field_errors}
                        </span>
                        )
                    }
                    return (
                        <span style={{display: "block"}}>
                        {typeof (fieldName) === "number" ? (
                            <>
                                {isArray(errorMessage) ? errorMessage.join(' ') : errorMessage}
                            </>
                        ) : (
                            <>
                                {fieldName}: {isArray(errorMessage) ? errorMessage.join(' ') : errorMessage}
                            </>
                        )}
                    </span>
                    )
                })
            }
        }
        if (error.response.status === 403) {
            if (!isEmpty(dataDetails)) {
                return map(dataDetails, (errorMessage, fieldName) => {
                    return (
                        <>
                            <span
                                style={{display: "block"}}>{fieldName}: {isArray(errorMessage) ? errorMessage.join(' ') : "Forbidden"}</span>
                        </>
                    )
                })
            }
            return 'You do not have access to this resource'
        } else if (error.response.status >= 500) {
            Sentry.captureException(error);
            return "Unexpected error occurred. Please contact support"
        }
        return error.response.statusText
    }
};


export const handleEditorNotification = (evt: any, _data: any) => {
    const {type} = _data;
    switch (type) {
        case "warning":
            message.warning(_data.message).then();
            break;
        case "info":
            message.info(_data.message).then();
            break;
        case "success":
            message.success(_data.message).then();
            break;
    }
    evt.stop();
};